import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home/Home";
import Narratives from "./pages/Narratives/Narratives";
import Movies from "./pages/Movies/Movies";
import MusicVideos from "./pages/MusicVideos/MusicVideos";
import Info from "./pages/Info/Info";
import Stills from "./pages/Stiils/Stills";
import Project from "./pages/Project/Project";
import StillsNav from "./components/StillsNav/StillsNav";
import StillsCategory from "./pages/StillsCategory/StillsCategory";
import PageFlash from "./components/PageFlash/PageFlash";
import ShutterIntro from "./components/ShutterIntro/ShutterIntro";

import "./App.css";

function App() {
  const location = useLocation();
  const isStills = location.pathname.startsWith("/stills");
  const isHome = location.pathname === "/";

  const [showIntro, setShowIntro] = useState(isHome);

  useEffect(() => {
    setShowIntro(isHome);
  }, [isHome]);

  // While intro is showing, render ONLY the intro
  if (showIntro) {
    return (
      <ShutterIntro
        logoSrc="/assets/brand/brand-title.png"
        hold={2500} // stays visible longer (adjust to taste)
        enterMs={700}
        exitMs={700}
        onComplete={() => setShowIntro(false)}
      />
    );
  }

  return (
    <div className="App">
      {/* DRAMATIC INTRO — render OUTSIDE <Routes>. 
         If you want it only on Home, keep the isHome check. */}

      <Header />
      <PageFlash duration={500} />
      {isStills && <StillsNav />}

      <main className="App__main">
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/narratives" element={<Narratives />} />
          <Route path="/movies" element={<Movies />} />
          <Route path="/music-videos" element={<MusicVideos />} />
          <Route path="/info" element={<Info />} />

          {/* Stills routes (no duplicates) */}
          <Route path="/stills" element={<Stills />} />
          <Route path="/stills/:slug" element={<StillsCategory />} />

          <Route path="/project/:slug" element={<Project />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
